import { PlotCreatePage } from '@/components/plots/plot-create-page'

export function OperationsPlotCreate() {
  return <PlotCreatePage plotsBasePath="/operations/plots" />
}
